import type { IRemoveProfile } from './index.h'

import { combine, createEvent, createStore, sample } from 'effector'
import { model as i18nModel } from '~/core/i18n'
import { register } from '~/core/repository'
import { profilesModel } from '~/entities/profiles'
import { model as sessionModel } from '~/entities/session'

export const openProfilesRemovePopup = createEvent<IRemoveProfile>()

export const closeProfilesRemovePopup = createEvent<void>()
const removeProfile = createEvent()

export const $profilesRemovePopup = createStore<IRemoveProfile>({
  condition: false,
})
  .on(openProfilesRemovePopup, (_, payload) => ({
    ...payload,
    condition: true,
  }))
  .reset(closeProfilesRemovePopup)

export const $profilesRemovePopupTitle = combine(
  i18nModel.$t,
  $profilesRemovePopup,
  ({ t }, popupInfo) =>
    t('profile_delete_text', {
      profile_name: popupInfo.username,
    })
)

sample({
  clock: removeProfile,
  source: {
    profilesRemovePopup: $profilesRemovePopup,
    activeProfile: profilesModel.$activeProfile,
  },
  filter: ({ profilesRemovePopup, activeProfile }) =>
    profilesRemovePopup.id != null &&
    activeProfile?.id !== profilesRemovePopup.id,
  fn: ({ profilesRemovePopup: { id, kidsProfile } }) => ({
    id: id!,
    kidsProfile,
  }),
  target: profilesModel.removeProfileFx,
})

sample({
  clock: [
    profilesModel.removeProfileFx.doneData,
    profilesModel.removeProfileFx.fail,
  ],
  target: closeProfilesRemovePopup,
})

sample({
  clock: sessionModel.$session,
  target: closeProfilesRemovePopup,
})

register(openProfilesRemovePopup, 'openProfilesRemovePopup')
register(closeProfilesRemovePopup, 'closeProfilesRemovePopup')
register($profilesRemovePopup, '$profilesRemovePopup')
register($profilesRemovePopupTitle, '$profilesRemovePopupTitle')
register(removeProfile, 'removeProfile')
